export const PRODUCT_TYPE_ICONS: Record<string, string> = {
  income: 'assets/icons/ticketLogo.svg',
  food: 'assets/icons/cenaLogo.svg',
  drinks: 'assets/icons/consumoLogo.svg',
  others: 'assets/icons/variosLogo.svg',
  guardarropa: 'assets/icons/wardobre-icon.svg',
  estacionamiento: 'assets/icons/parking-icon.svg',
  merchandising: 'assets/icons/merch-icon.svg',
  default: 'assets/icons/variosLogo.svg'
};

export function getProductIcon(type?: string): string {
  return PRODUCT_TYPE_ICONS[type ?? 'default'] || PRODUCT_TYPE_ICONS['default'];
}
